import { render, staticRenderFns } from "./IntroPlate.vue?vue&type=template&id=3d7e8358&"
import script from "./IntroPlate.vue?vue&type=script&lang=js&"
export * from "./IntroPlate.vue?vue&type=script&lang=js&"
import style0 from "./IntroPlate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports